<template>
  <div class="moderator-candidate-resumes-info">
    <BasePreloader v-if="pending"/>
    <div class="moderator-candidate-resumes-info__main-wrap">
      <div class="moderator-candidate-resumes-info__main-passport-wrap">
        <FileShow v-if="$get(passport, '[0].passport_page')"
                  :value="passport[0].passport_page"
                  @click.prevent="open = 0"
                  class="moderator-candidate-resumes-info__main-passport"/>
        <div v-else class="moderator-candidate-resumes-info__main-passport  _placeholder">
          {{ $tModeratorCandidates('No passport') }}
        </div>

        <BaseAlertInline :value="errorEvergreen"
                         class="moderator-candidate-resumes-info__error  _warning"/>

        <button @click.prevent="onGetEvergreen"
                class="moderator-candidate-resumes-info__get-evergreen  base-btn  base-btn--outline-blue">
          <span>{{ $tModeratorCandidates('Get data by EVERGREEN') }}</span>
          <BasePreloader v-if="pendingEvergreen"/>
        </button>
      </div>

      <div class="moderator-candidate-resumes-info__main">
        <BasePreloader v-if="pendingSave"/>
        <div style="width: 100%">
          <FileUpload :label="$tModeratorCandidates('Photo (EVERGREEN)')"
                      :value="newPhoto || photo"
                      @input="addPhoto"
                      @delete="deletePhoto"
                      :canDelete="!!newPhoto"
                      class="moderator-candidate-resumes-info__photo"/>
        </div>


        <!--        <div style="width: 100%;">-->
        <!--          {{ inputs }}-->

        <!--          <hr>-->
        <!--          {{inputs.name.value}}-->
        <!--          <hr>-->
        <!--          {{input_name}}-->
        <!--        </div>-->

        <BaseInput :label="$tModeratorCandidates('Name')"
                   v-model="input_first_name"
                   :error="inputs.first_name.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Surname')"
                   v-model="input_second_name"
                   :error="inputs.second_name.error"
                   class="moderator-candidate-resumes-info__input"/>
        <!--        <BaseSelect label="Статус заповнення анкети"-->
        <!--                    v-model="input_status"-->
        <!--                    :error="inputs.status.error"-->
        <!--                    class="moderator-candidate-resumes-info__input"/>-->
        <BaseInput :label="$tModeratorCandidates('Country (EVERGREEN)')"
                   v-model="input_country"
                   :error="inputs.country.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Date of birth (EVERGREEN)')"
                   v-model="input_date_of_birth"
                   :error="inputs.date_of_birth.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Expiration date (EVERGREEN)')"
                   v-model="input_expiration_date"
                   :error="inputs.expiration_date.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Date of issue (EVERGREEN)')"
                   v-model="input_date_of_issue"
                   :error="inputs.date_of_issue.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('MRZ (EVERGREEN)')"
                   v-model="input_mrz"
                   :error="inputs.mrz.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('MRZ type (EVERGREEN)')"
                   v-model="input_mrz_type"
                   :error="inputs.mrz_type.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Passport number (EVERGREEN)')"
                   v-model="input_number"
                   :error="inputs.number.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Authority that issued')"
                   v-model="input_authority"
                   :error="inputs.authority.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Nationality (EVERGREEN)')"
                   v-model="input_nationality"
                   :error="inputs.nationality.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Name (EVERGREEN)')"
                   v-model="input_names"
                   :error="inputs.names.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Surname (EVERGREEN)')"
                   v-model="input_surname"
                   :error="inputs.surname.error"
                   class="moderator-candidate-resumes-info__input"/>
        <BaseInput :label="$tModeratorCandidates('Sex (EVERGREEN)')"
                   v-model="input_sex"
                   :error="inputs.sex.error"
                   class="moderator-candidate-resumes-info__input"/>

        <BaseAlertInline :value="error"
                         class="moderator-candidate-resumes-info__error  _warning"/>

        <div class="moderator-candidate-resumes-info__main-footer">
          <button @click.prevent="onSend"
                  class="moderator-candidate-resumes-info__save-btn  base-btn  base-btn--blue">
            {{ $tModeratorCandidates('Save') }}
          </button>
        </div>
      </div>
    </div>

    <CoolLightBox v-if="$get(passport, '[0].passport_page')"
                  :items="[passport[0].passport_page]"
                  srcName="path"
                  :index="open"
                  @close="open = null"/>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from 'vuex'
  import mapVModelInputs from '@/helpers/mapVModelInputs'
  import FileUpload from '@/components/FileUpload'
  import FileShow from '@/components/FileShow'
  import BaseAlertInline from '@/components/BaseAlertInline'

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ '../../components/CoolLightBox')

  export default {
    name: 'AMCandidatesResumesPageResumeInfo',
    components: {
      BaseAlertInline,
      CoolLightBox,
      FileShow,
      FileUpload
    },
    props: {
      id: Number,
    },
    data() {
      return {
        open: null,
        unwatch: null
      }
    },
    computed: {
      ...mapState('candidatesResumes', [
        'pending',
        'pendingSave',
        'pendingEvergreen',
        'errorEvergreen',
        'error',
        'receivedData',
        'inputs',
        'photo',
        'newPhoto',
        'passport',
      ]),
      ...mapVModelInputs(
        'candidatesResumes',
        'candidatesResumes/setInput',
        'input_'
      )
    },
    methods: {
      ...mapMutations('candidatesResumes', [
        'setInput'
      ]),
      ...mapActions('candidatesResumes', [
        'load',
        'send',
        'addPhoto',
        'deletePhoto',
        'getEvergreen',
      ]),
      onSend() {
        this.send(this.id)
      },
      onGetEvergreen() {
        this.$vModal.open('confirm', {
          title: this.$tModeratorCandidates('Refresh data by EVERGREEN?'),
          onAccept: () => {
            this.getEvergreen(this.id)
            this.$vModal.close('confirm')
          }
        })
      }
    },
    created() {
      this.load(this.id)
    },
    watch: {
      receivedData(data) {
        if (data) {
          this.$emit('update', data)
        }
      }
    }
  }
</script>

<style lang="less">

</style>
